/* eslint-disable no-undef */
import { API_BASE_URL } from '../../../config'
import { Feature, Source } from './Map.types'
/**
 * transformTileRequest
 */
export const transformTileRequest = (url: string, resourceType?: string) => {
  try {
    if (!resourceType) return { url }

    const requestUrl = new URL(url)
    const apiUrl = new URL(API_BASE_URL as string)
    const apiPath = apiUrl.pathname.replace(/\/+$/, '')
    const isApiRequest =
      requestUrl.origin === apiUrl.origin &&
      (requestUrl.pathname === apiPath ||
        requestUrl.pathname.startsWith(`${apiPath}/`))

    if (isApiRequest) {
      // Public tiles stay anonymous even when a signed-in app shares this origin.
      const isPublicRequest = requestUrl.pathname.split('/').includes('public')
      const accessToken = isPublicRequest
        ? null
        : localStorage.getItem('jwt')?.trim()
      const headers: Record<string, string> = accessToken
        ? { Authorization: `Bearer ${accessToken}` }
        : {}

      // Convert long queries to POST requests to avoid URL length limits
      // The frontend marks these with __vtquery= in the URL
      const vtQueryMarker = '__vtquery='
      const markerIndex = url.indexOf(vtQueryMarker)

      if (markerIndex !== -1) {
        // Extract the base URL (before __vtquery=) and the query body
        const baseUrl = url.substring(0, markerIndex - 1) // remove trailing ? or &
        const encodedBody = url.substring(markerIndex + vtQueryMarker.length)
        const body = decodeURIComponent(encodedBody)

        return {
          url: baseUrl,
          method: 'POST' as const,
          headers: { ...headers, 'Content-Type': 'application/json' },
          body,
        }
      }

      return accessToken ? { url, headers } : { url }
    }
  } catch (error) {
    console.error('[transformTileRequest] ERROR:', error)
  }

  // Always return a valid RequestParameters object
  return { url }
}

// Helper function to get feature from map event
export const getEventFeature = (
  e: mapboxgl.MapMouseEvent
): Feature | undefined => {
  if (!e.features || e.features.length === 0) return undefined
  const feature = e.features[0]

  return {
    ...feature,
    x: e.point.x,
    y: e.point.y,
  } as Feature
}

// Helper function to add sources to map
export const addSourcesToMap = (sources: Source[], map: mapboxgl.Map) => {
  sources.forEach((source) => {
    if (!map.getSource(source.id)) {
      const { layers, id, ...sourceConfig } = source
      map.addSource(source.id, sourceConfig as any)

      layers.forEach((layer) => {
        if (!map.getLayer(layer.id)) {
          map.addLayer({
            ...layer,
            source: layer.source || source.id,
          } as any)
        }
      })
    }
  })
}

// Helper function to remove sources from map
export const removeSources = (sources: Source[], map: mapboxgl.Map) => {
  sources.forEach((source) => {
    source.layers.forEach((layer) => {
      if (map.getLayer(layer.id)) {
        map.removeLayer(layer.id)
      }
    })
    if (map.getSource(source.id)) {
      map.removeSource(source.id)
    }
  })
}
